module.exports = __webpack_public_path__ + "img/whathot_s03.9cd71fb5.png";